var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-question-wrapper"},[(_vm.question)?_c('div',{staticClass:"grid-question"},[(_vm.notFirst)?_c('h2',[_vm._v(_vm._s(_vm.question.intro))]):_vm._e(),(!_vm.notFirst)?_c('h2',[_vm._v(" Was möchten Sie "),_c('br',{staticClass:"mobile-selection"}),_vm._v(" reparieren lassen? ")]):_vm._e(),_c('div',{class:{
        'grid-question-options':
          _vm.question.config.options[0].title !== 'Uhr' &&
          _vm.question.config.options[0].title !== 'Schmuck',
      }},[_c('grid-option-list',{attrs:{"option-list":this.question.config.options}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }